/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {GetStartedModal} from "components/commons";
import {
  container
} from "../common";

const bannerThumbsUp = `${WealthyEnv.BROKING_CDN_URL}/banner-broking-landing.png`;
const wealthyLogo = `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`;

const propTypes = {
  partnerData: PropTypes.object,
  rCode: PropTypes.string,
  resetPin: PropTypes.bool,
  setToggleModal: PropTypes.func,
  toggleModal: PropTypes.bool
};

const HeroBanner = ({
  rCode,
  partnerData,
  resetPin,
  setToggleModal,
  toggleModal
}) => {
  const isPartnerValid = partnerData?.name ? true : false;
  return (
    <>
      <HomeBannerWrapper className={isPartnerValid ? "no-padding" : ""}>
        <LogoContainer>
          <HomeLink href={WealthyEnv.URL}>
            <LogoIcon
              alt="wealthy-logo"
              className={isPartnerValid ? "proposal-logo" : ""}
              src={wealthyLogo}
            />
          </HomeLink>
        </LogoContainer>

        {
          isPartnerValid ? (
            // <BannerContentWrapper className="proposal">
            //   <Content>
            //     <Quote>
            //           Here’s a proposal shared by your partner<br />
            //       <span>{partnerData.name} </span>
            //           to open a Demat account <br /> with Wealthy
            //     </Quote>
            //   </Content>
            //   <CtaButton
            //     className="hide-mobile"
            //     onClick={() => setToggleModal(!toggleModal)}
            //   >
            //     Get Started
            //   </CtaButton>
            //   <CtaButton
            //     className="show-mobile"
            //     onClick={() => setToggleModal(!toggleModal)}
            //   >
            //   Get Started
            //   </CtaButton>
            // </BannerContentWrapper>
            ""
          ) : (
            <BannerContentWrapper>
              <Content>
                <Tagline>Invest Smartly, <br />Trade Confidently</Tagline>
                <Quote>Make your trading experience <br /> as it should be.</Quote>
                <CtaButton
                  className="hide-mobile"
                  onClick={() => setToggleModal(!toggleModal)}
                >
                Get Started
                </CtaButton>
              </Content>
              <IconSection>
                <IconThumbsUp
                  alt="broking-banner"
                  src={bannerThumbsUp}
                />
              </IconSection>
              <CtaButton
                className="show-mobile"
                onClick={() => setToggleModal(!toggleModal)}
              >
                Get Started
              </CtaButton>
            </BannerContentWrapper>
          )
        }
      </HomeBannerWrapper>
      <GetStartedModal
        rCode={rCode}
        resetPin={resetPin}
        setToggleModal={setToggleModal}
        toggleModal={toggleModal}
      />
    </>
  );
};

const HomeBannerWrapper = styled.div`
  background-color: ${colors.magnolia};
  padding-bottom: 3rem;
  position: relative;

  @media (max-width: 768px) {
    padding-bottom: 3.7rem;
  }

  &.no-padding {
    padding-bottom: 0;
  }
`;

const LogoContainer = styled.div`
  padding: 3.5rem 0 2.5rem 4.5rem;

  @media (max-width: 1220px){
    padding-left: 2.4rem;
    padding-right: 2.4rem;
  }
`;

const HomeLink = styled.a``;

const LogoIcon = styled.img`
  height: 3.8rem;

  &.proposal-logo {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    height: 32px;
    margin-bottom: 4.2rem;
  }
`;

const BannerContentWrapper = styled(container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 51rem;

  &.proposal {
    height: unset;
  }

  @media (max-width: 1200px) {
    height: 40rem;
  }

  @media (max-width: 768px) { 
    height: 25rem;
  }

  @media (max-width: 576px) {
    height: unset;
    flex-direction: column;
    align-items: self-start;
  }

  @media (max-width: 1220px){
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;

const Content = styled.div``;

const Tagline = styled.h1`
  font-size: 5.2rem;
  font-family: 'Marcellus', serif;
  font-weight: 400;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 3.2rem;
  }
`;

const Quote = styled.p`
  font-size: 2.4rem;
  color: ${colors.textGray};
  padding-top: 2.4rem;

  span {
    font-weight: 600;
    color: ${colors.black};
    text-transform: capitalize;
  }

  @media (max-width: 768px) {
    font-size: 1.6rem;
    padding-top: 1.6rem;
  }
`;

const IconSection = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  @media (max-width: 992px) {
    top: 60px;
  }

  @media (max-width: 576px) { 
    width: 100%;
    position: relative;
    top: unset;
    right: unset;
  }
`;

const IconThumbsUp = styled.img`
  height: 62rem;

  @media (max-width: 1200px) {
    height: 50rem;
  }

  @media (max-width: 992px) {
    height: 40rem;
  }

  @media (max-width: 768px) {
    height: 30rem;
  }

  @media (max-width: 576px) {
    height: unset;
    width: 100%;
  }
`;

const CtaButton = styled.button`
  font-size: 1.8rem;
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 1.7rem 4.4rem;
  display: inline-block;
  border-radius: 100px;
  transition: all 0.15s ease-in-out;
  width: 300px;
  text-align: center;
  font-weight: 700;
  margin-top: 3.4rem;
  cursor: pointer;
  border: 0;
  font-weight: 400;

  &:hover {
    transform: translateY(-4px);
  }

  &.show-mobile {
    display: none;
  }

  @media (max-width: 768px) {
    font-size: 1.6rem;
    max-width: 280px;
    width: 180px;
    padding: 1.4rem 3.5rem;
  }

  @media (max-width: 576px) {
    &.hide-mobile {
      display: none;
    }
    
    &.show-mobile {
      display: block;
      width: 100%;
      max-width: unset;
    }
  }
`;

HeroBanner.propTypes = propTypes;

export default HeroBanner;
